import { BASE_URL } from '@/config'

export async function createController(controllerData) {
  try {
    const response = await fetch(`${BASE_URL}/control/controller`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(controllerData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao criar controlador')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao criar controlador:', error)
    throw error
  }
}

export async function getControllers() {
  try {
    const response = await fetch(`${BASE_URL}/control/controller`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar controladores')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar controladores:', error)
    throw error
  }
}

export async function assignController(id, controllerData) {
  if (!id) {
    throw new Error('O ID do controlador é obrigatório para atualização.')
  }
  console.log('controllerData', controllerData)

  if (controllerData && !controllerData.action) {
    throw new Error(
      'A ação (add/remove) é obrigatória para modificar EmpresaID.'
    )
  }

  try {
    const response = await fetch(`${BASE_URL}/control/updater/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(controllerData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao atualizar controlador')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao atualizar controlador:', error)
    throw error
  }
}

export async function updateController(id, controllerData) {
  if (!id) {
    throw new Error('O ID do controlador é obrigatório para atualização.')
  }

  try {
    const response = await fetch(`${BASE_URL}/control/updater/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(controllerData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao atualizar controlador')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao atualizar controlador:', error)
    throw error
  }
}

export async function deleteController(id) {
  if (!id) {
    throw new Error('O ID do controlador é obrigatório para exclusão.')
  }

  try {
    const response = await fetch(`${BASE_URL}/control/delete/${id}`, {
      method: 'DELETE',
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao excluir controlador')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao excluir controlador:', error)
    throw error
  }
}

export async function getControllersByEnterpriseId(enterpriseId) {
  try {
    const response = await fetch(
      `${BASE_URL}/control/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar controladores da empresa'
      )
    }

    return await response.json()
  } catch {
    throw error
  }
}

export async function getControllersCount() {
  try {
    const response = await fetch(`${BASE_URL}/control/count`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar quantidade de controles'
      )
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar quantidade de controles:', error)
    throw error
  }
}

export async function getControllersById(controllerId) {
  try {
    const response = await fetch(`${BASE_URL}/control/${controllerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar controladores da empresa'
      )
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar controladores da empresa:', error)
    throw error
  }
}

export async function getControllersInEmployees(EmployeesID) {
  try {
    const response = await fetch(
      `${BASE_URL}/control/employees/${EmployeesID}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar controladores da empresa'
      )
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar controladores da empresa:', error)
    throw error
  }
}
getControllersInEmployees('67ef0ebba58223a5caedeb45')
